import { DataSeriesLite } from './DataSeriesLite';
import { DataFrame, ColumnarData, ColumnVal } from './DataFrame';
import { DataPrimitive, DataType, IDataFrame } from './DataPrimitive';

/**
 * Base DataFrame class and associated DataFrame selectors
 * @implements {DataPrimitive}
 */
export class DataFrameLite<T extends DataType = DataType>
    extends DataFrame
    implements IDataFrame<DataType>, DataPrimitive<T>
{
    /**
     * Loads ColumnarData into a DataFrame
     * DataFrame contains DataSeries but without DataPoints
     * @param {ColumnarData} columnarData
     * @returns {DataFrame<T>}
     */
    static fromJsonCols<ColType extends DataType = DataType>(columnarData: ColumnarData): DataFrame<ColType> {
        if (!columnarData?.data) {
            return new DataFrame<ColType>([]);
        }
        const {
            data: { fields = [], columns = [] },
        } = columnarData;
        if (columns.length !== fields.length) {
            throw new Error(
                `number of columns (${columns.length}) does not match number of fields (${fields.length})`
            );
        }
        const dataSeries = [];
        columns.forEach((data: ColumnVal[], idx): void => {
            const fieldInfo: any = fields[idx];
            const field: string = fieldInfo.name || fieldInfo;
            const type: string = fieldInfo?.type;
            dataSeries.push(new DataSeriesLite(data, type, field));
        });
        return new DataFrame<ColType>(dataSeries);
    }
}
